export default "__VITE_ASSET__B0T03k37__"